import * as react from "react";
import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { validatedDatePicker, disabeldCheckboxWithTooltipMultiline, checkbox, adminImageUpload, validatedTextarea, validatedTextBox, pagination, errorMsg, spinner, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { BannerModel__get_CanSubmit, Filter, Msg, Page } from "./Types.fs.js";
import { ofArray, singleton as singleton_1, empty, map } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Option, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Option as Option_1, columns } from "../../../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { BannerProps, PreviewMode, bfsBanner, formatImageUrlMobile, formatImageUrlDesktop } from "../../User/Shared/Banner.fs.js";
import { Option as Option_2, select } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Select.fs.js";
import { Selector } from "../../../KundenTypSelector.fs.js";
import { Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";

export function tableRow(dispatch, navigateTo, banner) {
    let children_2, children_4, children_12, children_6, children_8, children_10;
    const aktiv = banner.Aktiv ? "" : "deaktiviert";
    const children_14 = [react.createElement("td", {}, banner.Titel), (children_2 = [toString(banner.GueltigAb, "dd.MM.yyyy")], react.createElement("td", {}, ...children_2)), (children_4 = [toString(banner.GueltigBis, "dd.MM.yyyy")], react.createElement("td", {}, ...children_4)), (children_12 = [(children_6 = [icon("fas fa-edit")], react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(1, [banner.Id]));
        },
        title: "bearbeiten",
    }, ...children_6)), banner.Aktiv ? ((children_8 = [icon("fas fa-eye-slash")], react.createElement("a", {
        onClick: (_arg_1) => {
            dispatch(new Msg(4, [banner.Id]));
        },
        title: "deaktivieren",
    }, ...children_8))) : ((children_10 = [icon("fas fa-eye")], react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(3, [banner.Id]));
        },
        title: "aktivieren",
    }, ...children_10)))], react.createElement("td", {}, ...children_12))];
    return react.createElement("tr", {
        className: aktiv,
    }, ...children_14);
}

export function table(banner, dispatch, navigateTo) {
    let children_10, children_8, children_12;
    const children_14 = [(children_10 = [(children_8 = [react.createElement("th", {}, "Titel"), react.createElement("th", {}, "Gültig ab"), react.createElement("th", {}, "Gültig bis"), react.createElement("th", {}, "Aktionen")], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_12 = map((banner_1) => tableRow(dispatch, navigateTo, banner_1), banner), react.createElement("tbody", {}, ...children_12))];
    return react.createElement("table", {
        className: "table table-striped responsive-table",
    }, ...children_14);
}

export function listPage(model, dispatch, navigateTo) {
    let children_32;
    let patternInput;
    const matchValue = model.Filter;
    patternInput = ((matchValue.tag === 1) ? ["is-outlined", "", "is-outlined", "is-outlined", "is-outlined"] : ((matchValue.tag === 3) ? ["is-outlined", "is-outlined", "", "is-outlined", "is-outlined"] : ((matchValue.tag === 2) ? ["is-outlined", "is-outlined", "is-outlined", "", "is-outlined"] : ((matchValue.tag === 4) ? ["is-outlined", "is-outlined", "is-outlined", "is-outlined", ""] : ["", "is-outlined", "is-outlined", "is-outlined", "is-outlined"]))));
    const children_34 = [(children_32 = toList(delay(() => {
        let children_30, children_28;
        return append(singleton((children_30 = [(children_28 = toList(delay(() => append(singleton(react.createElement("button", {
            className: "button is-link is-pulled-right is-small",
            onClick: (_arg) => {
                navigateTo(new Page(2, []));
            },
        }, "Neu")), delay(() => {
            let children_22, children_4, props_2, children_8, props_6, children_12, props_10, children_16, props_14, children_20, props_18;
            return append(singleton((children_22 = [(children_4 = [(props_2 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[0]]), new DOMAttr(40, [(_arg_1) => {
                dispatch(new Msg(2, [new Filter(0, [])]));
            }])], react.createElement("button", keyValueList(props_2, 1), "alle"))], react.createElement("p", {
                className: "control",
            }, ...children_4)), (children_8 = [(props_6 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[1]]), new DOMAttr(40, [(_arg_2) => {
                dispatch(new Msg(2, [new Filter(1, [])]));
            }])], react.createElement("button", keyValueList(props_6, 1), "nur Pflege"))], react.createElement("p", {
                className: "control",
            }, ...children_8)), (children_12 = [(props_10 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[2]]), new DOMAttr(40, [(_arg_3) => {
                dispatch(new Msg(2, [new Filter(3, [])]));
            }])], react.createElement("button", keyValueList(props_10, 1), "nur BFS Plus"))], react.createElement("p", {
                className: "control",
            }, ...children_12)), (children_16 = [(props_14 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[3]]), new DOMAttr(40, [(_arg_4) => {
                dispatch(new Msg(2, [new Filter(2, [])]));
            }])], react.createElement("button", keyValueList(props_14, 1), "nur Therapie"))], react.createElement("p", {
                className: "control",
            }, ...children_16)), (children_20 = [(props_18 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[4]]), new DOMAttr(40, [(_arg_5) => {
                dispatch(new Msg(2, [new Filter(4, [])]));
            }])], react.createElement("button", keyValueList(props_18, 1), "nur Jugendhilfe"))], react.createElement("p", {
                className: "control",
            }, ...children_20))], react.createElement("div", {
                className: "field has-addons",
            }, ...children_22))), delay(() => {
                let matchValue_1;
                return singleton((matchValue_1 = model.Banner, (matchValue_1.tag === 1) ? spinner : ((matchValue_1.tag === 2) ? errorMsg("Fehler beim Laden der Banner!") : ((matchValue_1.tag === 3) ? (equals(matchValue_1.fields[0].Items, empty()) ? react.createElement("div", {}, "Keine Banner vorhanden") : table(matchValue_1.fields[0].Items, dispatch, navigateTo)) : react.createElement("div", {})))));
            }));
        })))), react.createElement("div", {
            className: "card-body",
        }, ...children_28))], react.createElement("div", {
            className: "flat-card profile-info-card is-auto",
        }, ...children_30))), delay(() => {
            const matchValue_2 = model.Banner;
            if (matchValue_2.tag === 3) {
                return singleton(pagination(matchValue_2.fields[0], (page) => {
                    navigateTo(new Page(0, [page]));
                }));
            }
            else {
                return empty_1();
            }
        }));
    })), react.createElement("div", {
        className: "column is-12",
    }, ...children_32))];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children_34);
}

export function editBox(model, dispatch, navigateTo) {
    let children_46, children_4, children_2, children_44, children_8, children_12, children_16, children_26, children_24, props_20, props_22, children_30, children_42, children_40, children_34, props_32, children_38, children_36;
    const isLoading = model.Sending ? " is-loading" : "";
    return column(singleton_1(new Option(0, [new Screen(0, []), new ISize(16, [])])), singleton_1((children_46 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Banner bearbeiten")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_44 = [columns(empty(), ofArray([column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1(validatedTextBox((arg) => {
        dispatch(new Msg(9, [arg]));
    })("Tag")("Tag")("")(model.Tag))), column(singleton_1(new Option(0, [new Screen(0, []), new ISize(13, [])])), singleton_1(validatedTextBox((arg_1) => {
        dispatch(new Msg(10, [arg_1]));
    })("Titel")("Titel")("")(model.Titel)))])), columns(empty(), singleton_1(column(singleton_1(new Option(0, [new Screen(0, []), new ISize(16, [])])), singleton_1(validatedTextarea((arg_2) => {
        dispatch(new Msg(11, [arg_2]));
    }, "Text", "Text", "", "is-big", model.Text))))), columns(singleton_1(new Option_1(8, ["image-upload"])), ofArray([column(singleton_1(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton_1((children_8 = [react.createElement("label", {
        className: "label",
    }, "Hintergrundbild Desktop"), adminImageUpload(model.Id, model.HasImageDesktop, (id) => formatImageUrlDesktop(model.UploadTrigger, id), new Msg(18, []), (Item_3) => (new Msg(19, [Item_3])), dispatch, "Bitte speichern Sie das neu Banner bevor Sie ein Bild hochladen.", undefined)], react.createElement("div", {
        className: "field",
    }, ...children_8)))), column(singleton_1(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton_1((children_12 = [react.createElement("label", {
        className: "label",
    }, "Hintergrundbild Mobil"), adminImageUpload(model.Id, model.HasImageMobile, (id_1) => formatImageUrlMobile(model.UploadTrigger, id_1), new Msg(21, []), (Item_4) => (new Msg(22, [Item_4])), dispatch, "Bitte speichern Sie das neu Banner bevor Sie ein Bild hochladen.", undefined)], react.createElement("div", {
        className: "field",
    }, ...children_12))))])), columns(empty(), singleton_1(column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1((children_16 = [react.createElement("label", {
        className: "label",
    }, "Nur das Hintergrundbild anzeigen"), model.ImageOnlyEnabled ? checkbox(model.ImageOnly, (b) => {
        dispatch(new Msg(15, [b]));
    }, "") : disabeldCheckboxWithTooltipMultiline("Um diese Option zu aktivieren müssen Hintergrundbilder für Desktop und Mobil hinterlegt sein", (_arg) => {
    })], react.createElement("div", {
        className: "field",
    }, ...children_16)))))), columns(empty(), singleton_1(column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1((children_26 = [react.createElement("label", {
        className: "label",
    }, "Textfarbe"), select(singleton_1(new Option_2(11, [""])), singleton_1((children_24 = [(props_20 = [new HTMLAttr(161, ["#FFFFFF"]), new HTMLAttr(143, [model.TextFarbe === "#FFFFFF"])], react.createElement("option", keyValueList(props_20, 1), "Hell")), (props_22 = [new HTMLAttr(161, ["#4A4A4A"]), new HTMLAttr(143, [model.TextFarbe === "#4A4A4A"])], react.createElement("option", keyValueList(props_22, 1), "Dunkel"))], react.createElement("select", {
        className: "select input is-multiline is-multiple",
        onChange: (ev) => {
            dispatch(new Msg(17, [((ev.target.value) === "#FFFFFF") ? "#FFFFFF" : "#4A4A4A"]));
        },
    }, ...children_24))))], react.createElement("div", {
        className: "field",
    }, ...children_26)))))), columns(empty(), ofArray([column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1(validatedDatePicker((tupledArg) => (new Msg(12, [tupledArg[0], tupledArg[1]])), "Gültig ab", model.GueltigAb, dispatch))), column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1(validatedDatePicker((tupledArg_1) => (new Msg(13, [tupledArg_1[0], tupledArg_1[1]])), "Gültig bis", model.GueltigBis, dispatch))), column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1(Selector(model.KundenTyp, (kundentyp) => {
        dispatch(new Msg(16, [kundentyp]));
    }))), column(singleton_1(new Option(0, [new Screen(0, []), new ISize(7, [])])), singleton_1((children_30 = [react.createElement("label", {
        className: "label",
    }, "Aktiv"), checkbox(model.Aktiv, (b_1) => {
        dispatch(new Msg(14, [b_1]));
    }, "")], react.createElement("div", {
        className: "field",
    }, ...children_30))))])), (children_42 = [(children_40 = [(children_34 = [(props_32 = [new HTMLAttr(65, ["button is-link" + isLoading]), new HTMLAttr(79, [!BannerModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg_1) => {
        dispatch(new Msg(24, []));
    }])], react.createElement("button", keyValueList(props_32, 1), "Speichern"))], react.createElement("div", {
        className: "info-block is-pulled-right",
    }, ...children_34)), (children_38 = [(children_36 = [model.IsDirty ? "Abbrechen" : "Zurück"], react.createElement("button", {
        className: "button is-danger is-link",
        onClick: (_arg_2) => {
            navigateTo(new Page(0, [model.BackToPage]));
        },
    }, ...children_36))], react.createElement("div", {
        className: "info-block",
    }, ...children_38))], react.createElement("div", {
        className: "column is-12",
    }, ...children_40))], react.createElement("div", {
        className: "columns",
    }, ...children_42))], react.createElement("div", {
        className: "card-body",
    }, ...children_44))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto card-editor",
    }, ...children_46))));
}

export class PreviewBannerSize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Desktop", "Tablet", "Mobile"];
    }
}

export function PreviewBannerSize_$reflection() {
    return union_type("AdminBanner.View.PreviewBannerSize", [], PreviewBannerSize, () => [[], [], []]);
}

export function previewBanner(model, size) {
    let children_2, children;
    return column(ofArray([new Option(0, [new Screen(0, []), (size.tag === 1) ? (new ISize(10, [])) : ((size.tag === 2) ? (new ISize(7, [])) : (new ISize(16, [])))]), new Option(2, ["preview"])]), ofArray([(children_2 = [(children = [(size.tag === 1) ? "Vorschau Tablet" : ((size.tag === 2) ? "Vorschau Smartphone" : "Vorschau Desktop")], react.createElement("b", {}, ...children))], react.createElement("h3", {}, ...children_2)), bfsBanner(new BannerProps((_arg) => {
    }, (_arg_1) => {
    }, model.UserSession, model.Id, model.Tag.Value, model.Titel.Value, model.TextAsHtml, model.HasImageDesktop, model.HasImageMobile, model.ImageOnly, model.HintergrundFarbe, model.TextFarbe, model.UploadTrigger, (size.tag === 2) ? (new PreviewMode(2, [])) : ((size.tag === 1) ? (new PreviewMode(2, [])) : (new PreviewMode(1, [])))))]));
}

export function editPage(model, dispatch, navigateTo) {
    const children = [editBox(model, dispatch, navigateTo), columns(empty(), singleton_1(previewBanner(model, new PreviewBannerSize(0, [])))), columns(empty(), ofArray([previewBanner(model, new PreviewBannerSize(1, [])), column(singleton_1(new Option(0, [new Screen(0, []), new ISize(6, [])])), empty()), previewBanner(model, new PreviewBannerSize(2, []))]))];
    return react.createElement("div", {
        className: "banner-editor",
    }, ...children);
}

export function view(model, dispatch, navigateTo) {
    if (model.tag === 1) {
        return editPage(model.fields[0], dispatch, (arg_1) => {
            navigateTo(arg_1);
        });
    }
    else {
        return listPage(model.fields[0], dispatch, (arg) => {
            navigateTo(arg);
        });
    }
}

//# sourceMappingURL=View.fs.js.map
